import React from 'react';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';

const styles = theme => ({
  root: {
    color: theme.palette.secondary.text,
  },
  expandIcon: {
    color: theme.palette.secondary['300'],
    '&.Mui-expanded': {
      color: theme.palette.primary.main,
    },
  },
});


const ExpansionPanelSummary = (props) => {
  const { classes } = props;
  return (
    <MuiExpansionPanelSummary
      {...props}
      classes={{
        root: classes.root,
        expandIcon: classes.expandIcon,
      }}
    >
      {props.children}
    </MuiExpansionPanelSummary>
  );
};

ExpansionPanelSummary.propTypes = {
  children: PropTypes.element.isRequired,
};

export default withStyles(styles)(ExpansionPanelSummary);
